import { render, staticRenderFns } from "./vsNavbar.vue?vue&type=template&id=02a86abb&lang=html&"
import script from "./vsNavbar.vue?vue&type=script&lang=js&"
export * from "./vsNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsNavbar.vue"
export default component.exports